import {ImageResource} from '@services/resource/image-resource';
import {StartupResource} from '@services/resource/startup-resource';
import {UploadDocument} from '@services/resource/upload-document';
import {VideoResource} from '@services/resource/video-resource';

export class ProductResource {
  constructor(
    public id: string | undefined,
    public startupId: string,
    public name: string,
    public claim: string,
    public description: string,
    public listed: string,
    public uvp: number | undefined,
    public productGroup: string,
    public packingUnit: string,
    public coverImage: ImageResource | undefined,
    public images: ImageResource[],
    public pitchDeck: UploadDocument | undefined,
    public documents: UploadDocument[],
    public pitchVideo: VideoResource | undefined,
    public startup: StartupResource | null,
    public modified: string | undefined,
  ) {}
}
